import { AxiosError } from "axios"
import {
  denialReasonKey,
  extractDenialReason
} from "@/modals/constructor/inventory/InventoryModal/helpers"

export const clampDiscardQuantity = (raw: number, max: number): number => {
  if (Number.isNaN(raw)) {
    return 1
  }
  const int = Math.floor(raw)
  if (int < 1) {
    return 1
  }
  return int > max ? max : int
}

export type DiscardFailureOutcome =
  | "retry"
  | "rebound"
  | "closeAll"
  | "closeConfirm"
  | "stay"

export interface IDiscardFailureHandling {
  outcome: DiscardFailureOutcome
  toastKey: string
  keepPending: boolean
}

const REBOUND_REASONS = new Set([
  "INSUFFICIENT_QUANTITY",
  "VERSION_CONFLICT",
  "CONFLICT_RETRY_EXHAUSTED"
])

const CLOSE_ALL_REASONS = new Set(["INSTANCE_NOT_FOUND", "WRONG_OWNER"])

export const classifyDiscardFailure = (
  error: unknown
): IDiscardFailureHandling => {
  const response = (error as AxiosError | undefined)?.response
  if (!response || response.status >= 500) {
    return {
      outcome: "retry",
      toastKey: "inventory:denial.generic",
      keepPending: true
    }
  }
  const reason = extractDenialReason(error)
  if (!reason) {
    return {
      outcome: "stay",
      toastKey: "inventory:denial.generic",
      keepPending: false
    }
  }
  const toastKey = denialReasonKey(reason)
  if (REBOUND_REASONS.has(reason)) {
    return { outcome: "rebound", toastKey, keepPending: false }
  }
  if (CLOSE_ALL_REASONS.has(reason)) {
    return { outcome: "closeAll", toastKey, keepPending: false }
  }
  return { outcome: "closeConfirm", toastKey, keepPending: false }
}
